/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylistV2 } from 'src/core/themes/luisStylist';
import { StyledStack } from 'src/luis/verticals/getStartedGuide/components/GetStartedList';

const messages = defineMessages({
    addExampleItemBody: {
        id: 'portal.getStartedList.addExampleItemBody',
        defaultMessage: 'Provide example data which will be used by machine learning to train your app.'
    },
    addExampleStepOneStart: {
        id: 'portal.getStartedList.addExampleStepOneStart',
        defaultMessage: 'Create '
    },
    addExampleStepOneEnd: {
        id: 'portal.getStartedList.addExampleStepOneEnd',
        defaultMessage: 'intents.'
    },
    addExampleSteptwoStart: {
        id: 'portal.getStartedList.addExampleSteptwoStart',
        defaultMessage: 'Add '
    },
    addExampleSteptwoEnd: {
        id: 'portal.getStartedList.addExampleSteptwoEnd',
        defaultMessage: 'utterances.'
    },
    addExampleStepThreeStart: {
        id: 'portal.getStartedList.addExampleStepThreeStart',
        defaultMessage: 'Label '
    },
    addExampleStepThreeEnd: {
        id: 'portal.getStartedList.addExampleStepThreeEnd',
        defaultMessage: 'entities.'
    }
});

const urls = {
    intents: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-concept-intent',
    utterances: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-concept-utterance',
    entities: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-concept-entity-types'
};

const { getClassName } = getStylistV2('GetStartedGuide');

const oList = getClassName('oList', {
    listStylePosition: 'inside',
    marginTop: 18
});

export const AddExampleListItem = () => {
    const { localize } = useLocalization();

    return (
        <StyledStack style={{ paddingLeft: 40 }}>
            {localize(messages.addExampleItemBody)}
            <ol className={oList}>
                <li>
                    <span>
                        {localize(messages.addExampleStepOneStart)}
                        <a href={urls.intents}>{localize(messages.addExampleStepOneEnd)}</a>
                    </span>
                </li>
                <li>
                    <span>
                        {localize(messages.addExampleSteptwoStart)}
                        <a href={urls.utterances}>{localize(messages.addExampleSteptwoEnd)}</a>
                    </span>
                </li>
                <li>
                    <span>
                        {localize(messages.addExampleStepThreeStart)}
                        <a href={urls.entities}>{localize(messages.addExampleStepThreeEnd)}</a>
                    </span>
                </li>
            </ol>
        </StyledStack>
    );
};
